
/*
 * GLOBAL THEME READY
 */
$(window).ready(function() {
    loadPages();
    aosInit();
    onElementHeightChange(document.body, function(){
        AOS.refresh();
    });

    loadPages();
});

/*
 * GLOBAL THEME WINDOW RESIZE
 */
$(window).resize(function() {
    aosInit();
});


function loadPages() {
    var load = $(".load-page");
    load.fadeOut(400);
}





